// extracted by mini-css-extract-plugin
export default {"top":"Toast_top__KkcyR","wrap":"Toast_wrap__x9G8X","plain":"Toast_plain__1Z5C8","closable":"Toast_closable__boHZ2"};